import { XCircle, AlertTriangle, CheckCircle } from 'lucide-react'
import { QualityBadge } from './styles'

const QUALITY_LABELS = {
  0: { text: 'Mala calidad', Icon: XCircle },
  1: { text: 'Buena calidad', Icon: CheckCircle },
  2: { text: 'Calidad regular', Icon: AlertTriangle }
}

export const QualityIndicatorBadge = ({
  status,
  sourceLabel = '',
  textOverride = '',
  align = 'left',
  top = 12,
  offset
}) => {
  const qualityInfo = QUALITY_LABELS[status]
  if (!qualityInfo) return null

  const IconComponent = qualityInfo.Icon
  const resolvedText = textOverride || qualityInfo.text
  const label = sourceLabel ? `${sourceLabel}: ${resolvedText}` : resolvedText
  const safeAlign = align === 'right' ? 'right' : 'left'
  const resolvedOffset = Number.isFinite(offset)
    ? offset
    : safeAlign === 'right'
      ? 16
      : 28

  return (
    <QualityBadge $status={status} $align={safeAlign} $top={top} $offset={resolvedOffset}>
      <IconComponent />
      {label}
    </QualityBadge>
  )
}

export default QualityIndicatorBadge
